import React from 'react'
import Modal, { Header } from 'src/components/theme/Models/Modal'
import FormContext from './FormContext'
import FormSuspense from 'src/components/Forms/FormSuspense'
import Form from './Form'

interface AddModalProps {
  isOpen: boolean
  toggle: () => void
}

const AddModal: React.FC<AddModalProps> = (props) => {
  const { isOpen, toggle } = props

  return (
    <Modal
      title='Add Position'
      isOpen={isOpen}
      toggle={toggle}
      size='xl'
    >
      <Header title='Add Position' />
      <FormSuspense fallback={<Form toggle={toggle} disableSave />}>
        <FormContext toggle={toggle} />
      </FormSuspense>
    </Modal>
  )
}

export default AddModal
